<template>
	<div
		:class="{
			'layout__item u-6/24 u-7/24-desk default-mt u-1/1-portable portable-pl0 c-gl-compare-widget desk-pl0':
				viewType !== 'horizontal',
			opened: viewType !== 'horizontal' && isOpened,
		}"
	>
		<div class="c-filters-top-button u-desk-display--none u-bg-color-white p- u-border--bottom">
			<label
				for="filtersection-mobile"
				@click="updateButtonClicked()"
				class="c-button c-button--support mb0 u-1/1-portable"
			>
				<h5 class="u-weight--normal">Bekijk resultaten</h5>
			</label>
		</div>
		<div class="c-filter-section palm-pt pt- palm-pb0">
			<h5 class="pb- u-border--bottom ph0 portable-ph-">Uw gegevens</h5>
			<div class="c-filter-section__body pt0 portable-ph- ph0">
				<address-input
					:resolved-address="userAddress"
					:address="{
						Postalcode: userData.Postalcode,
						HouseNumber: userData.HouseNumber,
						HouseNumberAddition: userData.HouseNumberAddition,
					}"
					v-on:address-changed="setAddress"
				></address-input>
				<template v-if="userData.showGuesstimate">
					<div class="layout__item mt- u-1/2 c-filter-section__sub-heading pl0">
						<h6 class="small">Aantal personen</h6>
					</div>
					<div class="layout__item mt- u-1/2 c-filter-section__sub-heading pl-">
						<h6 class="small" v-if="userData.hasRedelivery">Aantal zonnepanelen</h6>
					</div>
				</template>
				<div class="estimate pl0 mb-" v-if="userData.showGuesstimate">
					<div class="layout layout--flush layout--middle">
						<div class="layout__item u-1/2 pv-- pl0 ml0">
							<person-selector
								class="u-bg-color-white u-border"
								v-on:changeusage="setUsageFromSelector"
								:personCount="userData.personCount"
							></person-selector>
						</div>
						<div class="layout__item u-1/2 pl-">
							<div v-if="userData.showGuesstimate && !userData.hasRedelivery">
								<label
									for="hasSolar"
									@click="userData.hasRedelivery = true"
									class="c-inputfields__label u-text-align--right u-display--block c-filter-section__sub-heading small u-text-decoration--underline"
									>Ik heb zonnepanelen</label
								>
							</div>

							<template v-if="userData.hasRedelivery">
								<div class="layout layout--flush">
									<div class="layout__item u-1/3">
										<button
											class="c-gl-compare-widget__solarpanel-min"
											@click="
												userData.SolarCount > 0 ? userData.SolarCount-- : false;
												setRedelivery(true);
											"
											type="button"
										>
											-
										</button>
									</div>
									<div class="layout__item u-1/3">
										<input
											tabindex="11"
											class="c-gl-compare-widget__solarpanel-input"
											pattern="[0-9]*"
											type="number"
											maxlength="3"
											min="0"
											max="36"
											value="0"
											name="solar-panels"
											v-model="userData.SolarCount"
											@change="setRedelivery(true)"
											id="solar-panels"
											placeholder="0"
										/>
									</div>
									<div class="layout__item u-1/3">
										<button
											class="c-gl-compare-widget__solarpanel-plus"
											@click="
												userData.SolarCount < 36 ? userData.SolarCount++ : false;
												setRedelivery(true);
											"
											type="button"
										>
											+
										</button>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div
					class="zeta mt0 u-white-space--nowrap layout__item u-1/1 pl0 c-gl-compare-widget__guesstimate-results"
					v-if="userData.showGuesstimate"
				>
					<label
						for="usageElectricitySingle"
						class="c-gl-compare-widget__electricity-usage u-display--inline-block"
					>
						<span class="u-text-color-black">{{ userData.HighElectricityConsumption }}</span>
						<abbr title="kilowattuur">&nbsp;kWh</abbr>
					</label>
					<label for="usageGas" class="c-gl-compare-widget__gas-usage u-display--inline-block ml-">
						<span class="u-text-color-black">{{ userData.GasConsumption }}</span>
						<abbr title="kubieke meter">
							m
							<sup>3</sup>
						</abbr>
					</label>
					<template v-if="userData.hasRedelivery">
						<label
							for="terugstroomhoog"
							class="c-gl-compare-widget__electricity-redelivery u-display--inline-block ml-"
							style
						>
							<span class="u-text-color-black">{{ userData.HighElectricityDeliveredBack }}</span>
							<abbr title="kilowattuur">&nbsp;kWh</abbr>
						</label>
					</template>
				</div>

				<template v-if="!userData.showGuesstimate">
					<input
						type="checkbox"
						id="energyProduction"
						class="c-inputfields__input--checkbox"
						:checked="userData.TypeMeter === 'double'"
						@change="toggleTypeMeter()"
					/>
					<label for="energyProduction" class="c-inputfields__label mt- mb-"
						>Ik heb een dubbele of slimme meter</label
					>
					<div class="layout">
						<div class="layout__item u-1/2">
							<label class="u-weight--bold mb--">Verbruik</label>
							<div class="u-position--relative">
								<input
									type="number"
									min="0"
									max="99999"
									@change="updateResults()"
									v-model="userData.HighElectricityConsumption"
									class="c-gl-compare-widget__electricity-input c-gl-input-box__input"
								/>
								<div class="c-gl-compare-widget__usage-unit">kWh</div>
							</div>
							<div class="u-text-color-grey--base zeta mb-">
								{{ userData.TypeMeter === 'double' ? 'Normaaltarief' : '' }}
							</div>
						</div>
						<div class="layout__item u-1/2">
							<div class="u-1/1">
								<label class="u-weight--bold mb--">Teruglevering</label>
								<div class="u-position--relative">
									<input
										type="number"
										min="0"
										max="99999"
										@change="redeliveryChanged()"
										v-model="userData.HighElectricityDeliveredBack"
										class="c-gl-compare-widget__redelivery-input c-gl-input-box__input"
									/>
									<div class="c-gl-compare-widget__usage-unit">kWh</div>
								</div>
							</div>
							<div v-if="userData.TypeMeter === 'double'" class="u-text-color-grey--base zeta mb-">
								Normaaltarief
							</div>
						</div>

						<div class="layout__item u-1/2" v-if="userData.TypeMeter === 'double'">
							<div class="u-position--relative">
								<input
									type="number"
									min="0"
									max="99999"
									@change="updateResults()"
									v-model="userData.LowElectricityConsumption"
									class="c-gl-compare-widget__electricity-input c-gl-input-box__input"
								/>
								<div class="c-gl-compare-widget__usage-unit">kWh</div>
							</div>
							<div class="u-text-color-grey--base zeta mb-">Daltarief</div>
						</div>
						<div class="layout__item u-1/2" v-if="userData.TypeMeter === 'double'">
							<div class="u-position--relative">
								<input
									type="number"
									min="0"
									max="99999"
									@change="redeliveryChanged()"
									v-model="userData.LowElectricityDeliveredBack"
									class="c-gl-compare-widget__redelivery-input c-gl-input-box__input"
								/>
								<div class="c-gl-compare-widget__usage-unit">kWh</div>
							</div>
							<div class="u-text-color-grey--base zeta mb-">Daltarief</div>
						</div>
						<div class="layout__item u-1/2 u-position--relative">
							<div class="u-position--relative">
								<input
									type="number"
									min="0"
									max="99999"
									@change="updateResults()"
									:disabled="userData.noGasConnection"
									v-model="userData.GasConsumption"
									class="c-gl-compare-widget__gas-input c-gl-compare-widget__gas-input c-gl-input-box__input"
								/>
								<div class="c-gl-compare-widget__usage-unit">m3</div>
							</div>
							<div class="u-text-color-grey--base zeta">Gasverbruik</div>
						</div>
						<div class="layout__item u-1/2 u-position--relative desk-pt-">
							<div class="u-position--relative">
								<input
									type="checkbox"
									v-model="userData.noGasConnection"
									class="c-inputfields__input--checkbox"
									@change="toggleGasConnection()"
									id="noGasConnection-input"
								/>
								<label
									for="noGasConnection-input"
									v-tooltip="'Wel een gasaansluiting, maar geen verbruik? Vul dan 1m3 in'"
									class="c-inputfields__label"
								>
									<small class="c-gl-compare-widget__no-gas-label ml0 tiny"
										>Geen gasaansluiting</small
									>
								</label>
							</div>
						</div>
					</div>
				</template>
				<div class="layout__item u-1/1 mt- pl0 mb u-text-align--left">
					<label
						@click="toggleGuesstimate()"
						class="c-link c-link--cta u-display--block custom"
						for="inputhelp0"
						v-if="!userData.noGasConnection"
						>{{ userData.showGuesstimate ? 'Ik weet mijn verbruik' : 'Help mij schatten' }}</label
					>
				</div>
				<h4 class="c-filter-section__sub-heading mb--">
					<label for="huidigeLeverancier">Huidige leverancier</label>
				</h4>

				<div class="o-select">
					<select v-model="userData.CurrentSupplier" @change="updateResults()" id="huidigeLeverancier">
						<option
							:disabled="supplier.Value === null"
							v-for="(supplier, $index) in Filters.RichSuppliers"
							:key="supplier.Key + $index"
							:value="supplier.Value"
						>
							{{ supplier.Text }}
						</option>
					</select>
					<div class="o-select__arrow">
						<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
							<path d="M8 7H0l4 5 4-5zm0-2H0l4-5 4 5z" fill="#3D3D3D" fill-rule="evenodd" />
						</svg>
					</div>
				</div>

				<a
					class="c-link u-text-color-grey u-text-color-evg mt pt- u-display--block u-text-align--center u-cursor--pointer"
					@click="resetFormData()"
				>
					<svg width="11" height="15" viewBox="0 0 11 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-trash u-display--inline-block u-text-color-evg u-vertical-align--middle ml-- mr- mb-- u-text-color--grey'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.184 15h6.632a.72.72 0 00.71-.701L10 4H1l.474 10.299a.72.72 0 00.71.701zM7 6.321C7 6.144 7.124 6 7.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C7.124 13 7 12.856 7 12.679V6.32zm-2 0C5 6.144 5.124 6 5.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C5.124 13 5 12.856 5 12.679V6.32zm-2 0C3 6.144 3.124 6 3.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C3.124 13 3 12.856 3 12.679V6.32zm4.337-5.31L7.335.172C7.335.078 7.265 0 7.18 0H3.82c-.085 0-.155.078-.155.173l.002.837H.468c-.257 0-.466.233-.466.52L0 3h11l.002-1.47c0-.287-.208-.52-.466-.52H7.337z" fill="#004A6B" fill-rule="evenodd"/></svg>
					Begin opnieuw met vergelijken
				</a>
			</div>
		</div>
		<div class="c-filter-section pv- portable-ph0 ph0">
			<results-meta-bar
				v-on:valuechanged="setMetaOptions"
				:sort-options="Filters.Sort"
				:cost-display-options="Filters.CostDisplay"
			></results-meta-bar>
		</div>
		<div class="c-filter-section">
			<div class="u-text-align--center u-border--top u-border--bottom portable-ph pv-">
				<a class="c-link u-text-color-grey u-text-color-evg u-cursor--pointer mb0 mt0" @click="resetFilters()">
					<svg width="11" height="15" viewBox="0 0 11 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-trash u-display--inline-block u-vertical-align--middle ml-- mr- mb-- u-text-color-grey'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.184 15h6.632a.72.72 0 00.71-.701L10 4H1l.474 10.299a.72.72 0 00.71.701zM7 6.321C7 6.144 7.124 6 7.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C7.124 13 7 12.856 7 12.679V6.32zm-2 0C5 6.144 5.124 6 5.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C5.124 13 5 12.856 5 12.679V6.32zm-2 0C3 6.144 3.124 6 3.278 6h.444c.154 0 .278.144.278.321v6.358c0 .177-.124.321-.278.321h-.444C3.124 13 3 12.856 3 12.679V6.32zm4.337-5.31L7.335.172C7.335.078 7.265 0 7.18 0H3.82c-.085 0-.155.078-.155.173l.002.837H.468c-.257 0-.466.233-.466.52L0 3h11l.002-1.47c0-.287-.208-.52-.466-.52H7.337z" fill="#004A6B" fill-rule="evenodd"/></svg>
					Reset filters
				</a>
			</div>
		</div>
		<div class="c-filter-section c-filter-section--bare ph0 portable-ph">
			<origin-electricity-filter
				class="mt-"
				v-on:valuechange="setOriginFilter"
				:title="'Duurzame energie'"
				:info-text="Filters.OriginHelpText"
				:filter-values="Filters.OriginElectricity"
			></origin-electricity-filter>
			<div class="layout__item u-1/1" v-if="!userData.noGasConnection">
				<input
					type="checkbox"
					v-model="userData.CO2compensated"
					class="c-inputfields__input--checkbox"
					@change="updateResults()"
					id="co2compensated-input"
				/>
				<label for="co2compensated-input" class="c-inputfields__label">CO2 Gecompenseerd gas</label>
			</div>

			<checkbox-filter
				class="mt"
				v-on:valuechange="setContractTypeFilters"
				:title="'Looptijd &amp; tariefftype'"
				:is-duration-filter="true"
				:filter-values="Filters.ContractType"
			></checkbox-filter>

			<checkbox-filter
				class="mt"
				v-on:valuechange="setSupplierFilter"
				:title="'Aanbieders'"
				:all-none="true"
				:filter-values="Filters.Suppliers"
			></checkbox-filter>
		</div>
	</div>
</template>

<script>
import PackageFilters from './PackageFilters.js';
export default {
	extends: PackageFilters,
};
</script>
